export default {
  banks: [],
  bankAccounts: [],
  bankAccountTypes: [],
  bankWebhooks: [],
  financeCategories: [],
  financeTransations: [],
  financeTransactionsCount: 0,
  selectedBankAccount: {},
  selectedFinanceCategory: {},
  selectedFinanceTransaction: {}
}
